/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

function registerEventHandler(dObject, sEventName, fHandler) {
  if (dObject.attachEvent)
    dObject.attachEvent('on' + sEventName, fHandler);
  else if (dObject.addEventListener)
    dObject.addEventListener(sEventName, fHandler, true);
}

var TOUCHFlag = ('ontouchstart' in document);


var scroller_window = window.scroller_controller = null;

// Костыль для связи нативной анимации с джейТвинером

var STRIPE = null;
function initProductsScroller(container) {
  scroller = container;
  scroller.scroller_window = new ClassScrollerWindow(scroller.children[1]);
  scroller.scroller_window.moveToPercent(0);
  STRIPE = jQuery(scroller).find('.products')[0];
  jQuery(scroller).find('.scroller')[0].style.display = 'block';
  
  scroller.scroller_controller = new ClassScrollerController(scroller.children[0], scroller.scroller_window);
  
  var class_name = 'scroller__item';
  
  $(scroller.scroller_window.dWindow).find('.product[data-category]').each(function (i, item) {
    var category = jQuery(item).attr('data-category');
    var left = item.offsetLeft / scroller.scroller_window.iStripeWidth * 100;
    var span = document.createElement('div');
    span.innerHTML = '<span class="link link_grey link_pseudo">' + category + "</span>";
    span.className = class_name;
    span.style.left = left + '%';
    scroller.scroller_controller.dWindow.appendChild(span);
  });
  
  scroller.scroller_controller.analizeContent();
  
  var $dStripe = jQuery(scroller.scroller_window.dStripe);
  $dStripe.addClass('onActive');
  
  registerEventHandler(window, 'resize', redrawPortfolio);
  
  jTweener.removeTween();
  redrawPortfolio();
  
  flinging(scroller);
}
function ClassScrollerWindow(sId) {
  var oThis = this;
  this.dWindow = sId;
  
  this.dWindow.style.position = 'relative';
  this.dStripe = this.dWindow.firstChild;
  while (this.dStripe.nodeType != 1) this.dStripe = this.dStripe.nextSibling;
  this.dStripe.style.position = 'absolute';
  this.iWindowWidth = this.dWindow.offsetWidth;
  this.iStripeWidth = this.dStripe.offsetWidth;
  this.tMoveTimer = null;
  this.iPercent = null;
  this.iToPercent = null;
  this.redraw = function (iControllPercent) {
    this.iWindowWidth = this.dWindow.offsetWidth;
    this.iStripeWidth = this.dStripe.offsetWidth;
    
    if (iControllPercent) this.iPercent = iControllPercent;
    else return;
    this.startSlideToPercent(this.iPercent);
  };
  this.moveToPercent = function (iPercent) {
    this.iPercent = iPercent;
    this.dStripe.style.left = -Math.ceil(this.iStripeWidth * iPercent / 100) + 'px';
  };
  this.slideToPercent = function () {
    var flag = 0;
    if (Math.abs(this.iPercent - this.iToPercent) < 0.5 || (flag = this.iPercent * this.iStripeWidth / 100 + this.iWindowWidth >= this.iStripeWidth)) {
      if (this.tMoveTimer) {
        clearInterval(this.tMoveTimer);
        this.tMoveTimer = null;
        if (flag) this.iPercent = (this.iStripeWidth - this.iWindowWidth - 1) / this.iStripeWidth * 100;
      }
    }
    else {
      var distance = this.iPercent - this.iToPercent;
      var dirrection = distance / Math.abs(distance);
      var increase = 0.05 * Math.pow(Math.abs(distance), 1.5);
      this.moveToPercent(this.iPercent - increase * dirrection);
    }
  };
  this.startSlideToPercent = function (iPercent) {
    jTweener.removeTween();
    if (!this.tMoveTimer) this.tMoveTimer = setInterval(function () {
      oThis.slideToPercent();
    }, 50);
    this.iToPercent = iPercent;
  }
}
function ClassScrollerController(sId, oUke) {
  var oThis = this;
  this.oScroller = oUke;
  this.dWindow = jQuery(scroller).find(sId)[0];
  disableSelection(jQuery(this.dWindow));
  this.dWindow.style.position = 'relative';
  this.dRoller = this.dWindow.children[0];
  while (this.dRoller.nodeType != 1) this.dRoller = this.dRoller.nextSibling;
  this.dRoller.style.position = 'absolute';
  this.iLeftWindowOffset = this.dWindow.offsetLeft;
  this.iCatchLeftOffset = 0;
  this.iWindowWidth = this.dWindow.offsetWidth;
  this.iRollerWidth = this.dRoller.offsetWidth;
  this.iRollerWidth = Math.ceil(this.iWindowWidth * this.oScroller.iWindowWidth / this.oScroller.iStripeWidth);
  
  
  this.dRoller.style.width = this.iRollerWidth + 'px';
  this.tMoveTimer = null;
  this.iPercent = null;
  this.iToPercent = null;
  this.redraw = function () {
    this.iWindowWidth = this.dWindow.offsetWidth;
    this.iRollerWidth = this.dRoller.offsetWidth;
    this.iRollerWidth = Math.ceil(this.iWindowWidth * this.oScroller.iWindowWidth / this.oScroller.iStripeWidth);
    this.dRoller.style.width = this.iRollerWidth + 'px';
    this.iPercentWidth = this.iRollerWidth / this.iWindowWidth * 100;
    this.iPercent = this.iEndPercent - this.iPercentWidth;
    this.moveToPosition(this.iPercent);
    this.iPercent = this.dRoller.offsetLeft / this.iWindowWidth * 100;
  };
  var rollerLeftStart, rollerTopStart;
  var checkedRollerDirectionFlag = false;
  var movableRollerFlag = false;
  
  this.dRoller.onmousedown = function (event) {
    oThis.catchRoller(event);
  };
  
  this.catchRoller = function (event) {
    var $dRoller = jQuery(oThis.dRoller);
    
    $dRoller.addClass('grabbing');
    jTweener.removeTween(); // Удаление анимации с инерцией
    if (!event) event = window.event;
    if (!TOUCHFlag) {
      rollerLeftStart = event.clientX;
    } else {
      rollerLeftStart = event.targetTouches[0].clientX;
      rollerTopStart = event.targetTouches[0].clientY;
    }
    this.iCatchLeftOffset = rollerLeftStart - this.dRoller.offsetLeft - this.iLeftWindowOffset;
    var body = document.getElementsByTagName('body')[0];
    if (!TOUCHFlag) {
      body.onmousemove = function (event) {
        oThis.moveRoller(event);
      }
      body.onmouseup = function () {
        $dRoller.removeClass('grabbing');
        oThis.dropRoller();
      }
    } else if (TOUCHFlag && event.targetTouches.length > 1) {
      return false;
    }
    if (event.preventDefault) event.preventDefault();
    else event.returnValue = false;
    if (this.oScroller.tMoveTimer) this.oScroller.tMoveTimer = clearTimeout(this.oScroller.tMoveTimer);
    
  };
  this.moveRoller = function (event) {
    var rollerLeftNow, rollerTopNow;
    if (!event) event = window.event;
    if (!TOUCHFlag) {
      rollerLeftNow = event.clientX;
    } else {
      rollerLeftNow = event.targetTouches[0].clientX;
      rollerTopNow = event.targetTouches[0].clientY;
    }
    function act() {
      if (oThis.tMoveTimer) {
        oThis.tMoveTimer = clearTimeout(oThis.tMoveTimer);
        oThis.oScroller.tMoveTimer = clearTimeout(oThis.oScroller.tMoveTimer);
      }
      var iLeft = rollerLeftNow - oThis.iLeftWindowOffset - oThis.iCatchLeftOffset;
      
      if (iLeft < 0) iLeft = 0;
      if (iLeft + oThis.iRollerWidth > oThis.iWindowWidth) iLeft = oThis.iWindowWidth - oThis.iRollerWidth;
      
      oThis.iPercent = iLeft / oThis.iWindowWidth * 100;
      oThis.dRoller.style.left = iLeft + 'px';
      oThis.oScroller.moveToPercent(oThis.iPercent);
      
      oThis.iEndPercent = (oThis.dRoller.offsetLeft + oThis.iRollerWidth) / oThis.iWindowWidth * 100;
    }
    
    if (!TOUCHFlag) {
      act();
    } else if (TOUCHFlag && event.targetTouches.length == 1) {
      if (!checkedRollerDirectionFlag) {
        if (Math.abs(rollerLeftNow - rollerLeftStart) - Math.abs(rollerTopNow - rollerTopStart) >= -5) {
          movableRollerFlag = true;
          event.preventDefault();
        }
        checkedRollerDirectionFlag = true;
      } else if (movableRollerFlag) {
        act();
      }
    }
  };
  this.dropRoller = function () {
    var body = document.getElementsByTagName('body')[0];
    if (!TOUCHFlag) {
      body.onmousemove = null;
      body.onmouseup = null;
    } else {
      this.dContrStripe.removeEventListener('touchmove', oThis.moveRoller, false);
      this.dContrStripe.removeEventListener('touchend', oThis.dropRoller, false);
    }
    movableRollerFlag = false;
    checkedRollerDirectionFlag = false;
  };
  this.moveToPosition = function (iPercent) {
    this.iPercent = iPercent;
    
    var iLeft = Math.ceil(this.iWindowWidth * iPercent / 100);
    if (iLeft < 0) {
      iLeft = 0;
      this.iPercent = 0;
    }
    if (iLeft + this.iRollerWidth > this.iWindowWidth) {
      iLeft = this.iWindowWidth - this.iRollerWidth;
      this.iPercent = iLeft / this.iWindowWidth * 100;
    }
    this.dRoller.style.left = iLeft + 'px';
    this.iEndPercent = (this.dRoller.offsetLeft + this.iRollerWidth) / this.iWindowWidth * 100;
    this.oScroller.moveToPercent(this.iPercent);
  };
  this.moveToPercent = function (iPercent) {
    this.iPercent = iPercent;
    var iLeft = Math.ceil(this.iWindowWidth * iPercent / 100);
    if (iLeft < 0) {
      iLeft = 0;
      this.iPercent = this.iToPercent;
      if (this.tMoveTimer) this.tMoveTimer = clearTimeout(this.tMoveTimer);
      this.iPercent = 0;
    }
    if (iLeft + this.iRollerWidth > this.iWindowWidth) {
      this.iPercent = this.iToPercent;
      iLeft = this.iWindowWidth - this.iRollerWidth;
      if (this.tMoveTimer) this.tMoveTimer = clearTimeout(this.tMoveTimer);
      this.iPercent = iLeft / this.iWindowWidth * 100;
    }
    
    this.dRoller.style.left = iLeft + 'px';
    this.iEndPercent = (this.dRoller.offsetLeft + this.iRollerWidth) / this.iWindowWidth * 100;
  };
  this.slideToPercent = function () {
    if (Math.abs(this.iPercent - this.iToPercent) < 0.5) {
      if (this.tMoveTimer) {
        clearInterval(this.tMoveTimer);
        this.tMoveTimer = null;
        this.iEndPercent = (this.dRoller.offsetLeft + this.iRollerWidth) / this.iWindowWidth * 100;
      }
    }
    else {
      var distance = this.iPercent - this.iToPercent;
      var dirrection = distance / Math.abs(distance);
      var increase = 0.05 * Math.pow(Math.abs(distance), 1.5);
      var iPercent = this.iPercent - increase * dirrection;
      this.moveToPercent(iPercent);
      this.oScroller.startSlideToPercent(iPercent);
      this.iEndPercent = (this.dRoller.offsetLeft + this.iRollerWidth) / this.iWindowWidth * 100;
    }
  };
  this.preventDefault = function (event) {
    if (!event) event = window.event;
    if (event.preventDefault) event.preventDefault();
    else event.returnValue = false;
  };
  this.stopPropagation = function (event) {
    if (!event) event = window.event;
    if (event.stopPropagation) event.stopPropagation();
    else event.cancelBubble = true;
  };
  this.dWindow.onmousedown = function (event) {
    if (TOUCHFlag || event.which < 2) {
      oThis.preventDefault(event)
    }
  };
  this.startSlideToPercent = function (iPercent) {
    jTweener.removeTween();
    redrawPortfolio();
    if (!this.tMoveTimer) this.tMoveTimer = setInterval(function () {
      oThis.slideToPercent();
    }, 50);
    this.iToPercent = iPercent;
  };
  
  this.analizeContent = function () {
    var elements = this.dWindow.getElementsByTagName('div');
    var memory_w = 0, start_i = 0;
    for (var i in elements) {
      var width = false;
      try {
        width = parseFloat(elements[i].style.left) - parseFloat(elements[i - 2 + 1].style.left);
      } catch (err) {
      }
//			if (/<i>&nbs/.test(elements[i].innerHTML)) {
//
//				if (!start_i) start_i = i;
//				if (width) memory_w += width;
//				elements[i].style.display = 'none';
//				continue;
//			}
      if (width) {
        elements[start_i].style.width = memory_w + width + '%';
        elements[i].style.width = '3%';
      }
      memory_w = 0;
      start_i = i;
      elements[i].onclick = function (event) {
        oThis.getClick(event)
      };
    }
  };
  
  this.getClick = function (event) {
    if (!event) event = window.event;
    if (!event.target) event.target = event.srcElement;
    var target = event.target;
    
    while (!/div/i.test(target.nodeName)) {
      target = target.parentNode;
    }
    var left = target.offsetLeft;
    
    var percent = left / this.iWindowWidth * 100;
    this.startSlideToPercent(percent - 1);
    this.stopPropagation(event);
  }
  
}

function redrawPortfolio() {
  var $cont = jQuery('.scroller');
  $cont.each(function () {
    if (scroller.scroller_controller.iRollerWidth >= scroller.scroller_controller.iWindowWidth) {
      scroller.scroller_controller.dWindow.style.visibility = 'hidden';
      scroller.scroller_controller.dRoller.style.visibility = 'hidden';
    } else {
      scroller.scroller_controller.dWindow.style.visibility = 'visible';
      scroller.scroller_controller.dRoller.style.visibility = 'visible';
    }
    
    scroller.scroller_window.redraw(scroller.scroller_controller.iPercent);
    scroller.scroller_controller.redraw();
    scroller.scroller_window.redraw(scroller.scroller_controller.iPercent);
    
  });
  
}
/* Перетаскивание картинок с инерцией */
function flinging(container) {
  
  var scroller_window_ap = jQuery(container.scroller_window.dWindow);
  var $scroller_stripe = jQuery(container.scroller_window.dStripe);
  var start_left, stop_left, min_left, time_tick, left_tick;
  
  function preventClick(event) {
    event.preventDefault();
  }
  
  $scroller_stripe.find('.product a').bind("click", preventClick);
  
  
  var $document = jQuery(document);
  var mouseLeftStart, mouseTopStart;
  var checkedDirectionFlag = false;
  var movableFlag = false;
  var prevMouseUpTime = 0;
  var prevDirection;
  
  
  function stripeMouseDown(event) {
    if (TOUCHFlag || event.which < 2) {
      function act() {
        start_left = $scroller_stripe.position().left;
        min_left = -($scroller_stripe.innerWidth() - scroller_window_ap.width());
        time_tick = [];
        left_tick = [];
        jTweener.removeTween();
        
        container.scroller_controller.tMoveTimer = clearTimeout(container.scroller_controller.tMoveTimer);
        container.scroller_controller.oScroller.tMoveTimer = clearTimeout(container.scroller_controller.oScroller.tMoveTimer);
        var iPercent = start_left / container.scroller_window.iStripeWidth * (-1) * 100;
        container.scroller_controller.moveToPercent(iPercent);
      }
      
      var target = jQuery(event.target);
      $scroller_stripe.addClass("grabbing");
      if (!TOUCHFlag) {
        mouseLeftStart = event.pageX;
        event.preventDefault();
        act();
        $document.mousemove(stripeMouseMove);
        $document.mouseup(stripeMouseUp);
      } else if (TOUCHFlag && event.targetTouches.length == 1) {
        mouseLeftStart = event.targetTouches[0].pageX;
        mouseTopStart = event.targetTouches[0].pageY;
        act();
        container.scroller_window.dStripe.addEventListener('touchmove', stripeMouseMove, false);
        container.scroller_window.dStripe.addEventListener('touchend', stripeMouseUp, false);
      } else if (TOUCHFlag && event.targetTouches.length > 1) {
        return false;
      }
// }
    }
  }
  
  function stripeMouseMove(event) {
    var mouseLeftNow, mouseTopNow;
    
    function act() {
      event.preventDefault();
      var different = mouseLeftNow - mouseLeftStart;
      var now_left = start_left + different;
      /* Сопротивление */
      if (now_left < min_left) {
        now_left = Math.round(now_left + ((min_left - now_left) / 1.25));
      } else if (now_left > 0) { /* Сопротивление */
        now_left = Math.round(now_left - (now_left / 1.25));
      }
      
      $scroller_stripe.css({"left": now_left});
      time_tick.push(event.timeStamp);
      left_tick.push(now_left);
      var iPercent = now_left / container.scroller_window.iStripeWidth * (-1) * 100;
      container.scroller_controller.moveToPercent(iPercent);
    }
    
    if (!TOUCHFlag) {
      mouseLeftNow = event.pageX;
      act();
    } else if (TOUCHFlag && event.targetTouches.length == 1) {
      mouseLeftNow = event.targetTouches[0].pageX;
      mouseTopNow = event.targetTouches[0].pageY;
      if (!checkedDirectionFlag) {
        if (Math.abs(mouseLeftNow - mouseLeftStart) - Math.abs(mouseTopNow - mouseTopStart) >= -5) {
          movableFlag = true;
          event.preventDefault();
        }
        checkedDirectionFlag = true;
      } else if (movableFlag) {
        act();
      }
    }
  }
  
  function stripeMouseUp(event) {
    if (!TOUCHFlag || !event.targetTouches.length) {
      if (!TOUCHFlag) {
        $document.unbind('mouseup');
        $document.unbind('mousemove');
      } else {
        container.scroller_window.dStripe.removeEventListener('touchmove', stripeMouseMove, false);
        container.scroller_window.dStripe.removeEventListener('touchend', stripeMouseUp, false);
      }
      stop_left = $scroller_stripe.position().left;
      var timeStamp = event.timeStamp;
      var upTimeDiff = timeStamp - prevMouseUpTime;
      var direction = start_left - stop_left >= 0;
      var target = jQuery(event.target);
      var href = target.attr('href');
      if (!href) href = target.parents('a').attr('href');
      $scroller_stripe.removeClass("grabbing");
      /*Если двинули слишком влево*/
      if (stop_left < min_left) {
        jTweener.removeTween();
        jTweener.addTween($scroller_stripe, {left: min_left, time: 1, transition: "easeoutexpo"});
      }
      /*Или слишком вправо*/
      else if (stop_left > 0) {
        jTweener.removeTween();
        jTweener.addTween($scroller_stripe, {left: 0, time: 1, transition: "easeoutexpo"});
      }
      /*Если всё в допустимиых пределах*/
      else {
        /*Позиция одно мгновение назад*/
        var before_stop_time = timeStamp - 100;
        var diff_time, min_diff_time, diff_take;
        if (!time_tick) return;
        for (i = 0; i < time_tick.length; i++) {
          diff_time = Math.abs(before_stop_time - time_tick[i]);
          if (i == 0) {
            min_diff_time = diff_time;
          }
          if (diff_time <= min_diff_time) {
            diff_take = i;
            min_diff_time = diff_time;
          }
        }
        if (Math.abs(start_left - stop_left) > 3) {
          var flinging_left = left_tick[diff_take];
          /*На сколько сдвинули (если сдвинули) за последнее мгновение. Оцениваем размах*/
          if (Math.abs(time_tick[time_tick.length - 1] - timeStamp) <= 100 && flinging_left && flinging_left != stop_left) {
            var flinging_power = stop_left - flinging_left;
            var doubleBoost = upTimeDiff <= 1000 && direction == prevDirection ? upTimeDiff / 1000 : 0;
            var diff = flinging_power * 2 + flinging_power * doubleBoost;
            var new_left = stop_left + diff;
            var time = 1;
            if (new_left < min_left) {
              time = Math.abs(time / ((diff) / (Math.abs(diff) - Math.abs(new_left - min_left))));
              new_left = min_left;
            }
            if (new_left > 0) {
              time = Math.abs(time / ((diff) / (Math.abs(diff) - Math.abs(new_left))));
              new_left = 0;
            }
            
            scroller_window_ap.context.Portfolio ? (new_left < min_left + 40 ? nextGood.css({'left': 0}) : nextGood.css({'left': '500px'})) : false;
            
            /*Время — чем дальше, тем дольше*/
            jTweener.removeTween();
            jTweener.addTween($scroller_stripe, {
              onUpdate: redrawScrollerOnAnimation,
              onUpdateParams: [container],
              left: new_left,
              time: time,
              transition: "easeoutexpo"
            });
          }
        } else if (href && !checkedDirectionFlag) {
          document.location = href;
        }
      }
      movableFlag = false;
      checkedDirectionFlag = false;
      prevDirection = direction;
      prevMouseUpTime = timeStamp;
    }
  }
  
  if (!TOUCHFlag) {
    $scroller_stripe.mousedown(stripeMouseDown);
  } else {
    container.scroller_window.dStripe.addEventListener('touchstart', stripeMouseDown, false);
  }
  
}
function redrawScrollerOnAnimation(container) {
  var iPercent = container.scroller_window.dStripe.offsetLeft / container.scroller_window.iStripeWidth * (-1) * 100;
  container.scroller_controller.moveToPercent(iPercent);
}
function disableSelection(target) {
  target
    .mousemove(function (e) {
      e.preventDefault();
    })
    .mousedown(function (e) {
      e.preventDefault();
    });
}
}.call(window));